import {Component, Mixins} from "vue-property-decorator";
import {SimpleModal} from "~/components/modals/simple-modal";
import XSelect from '~/components/forms/x-select';
import {distinct} from "~/lib/helpers";

const separatorDict = [
  { char: ';', label: "Point-virgule" },
  { char: '\u000A', label: "Retour à la ligne" }
];

@Component
export class SearchListModal extends Mixins(SimpleModal) {

  public inputText: string = null;
  public separator: string = ';';

  commit() {
    const values = distinct(
      (
        this.separator !== '\u000A' ?
          this.inputText.replaceAll('\u000A', this.separator)
          :this.inputText
      )
        .split(new RegExp(`(?<!\\\\)\\${this.separator}`, 'gi'))
        .map(token => token.trim())
        .filter(token => token.length)
    );
    this.$emit('commit', values);
  }

  renderHead() {
    return <div class="modal-card-title" style="text-align: center">Recherche par liste</div>
  }

  renderBody() {
    return [
      <div style="padding-bottom: 15px">Veuillez écrire ou coller une liste d'éléments à chercher,
        séparés par des retour à la ligne ou des point-virgule selon votre choix :</div>,
      <textarea class="textarea"
                v-model={this.inputText}/>,
      <div style="padding-top: 15px">Séparateur :</div>,
      // FIXME : récupéré du front, mais provoque l'affichage d'un double arrow
      // <div class="select composition-selection">
        <XSelect value={this.separator}
                 data={separatorDict}
                 label={d => d.label}
                 onInput={d => this.separator = d.char}
                 equality={(d: any, sep) => d.char === sep}
        />
      // </div>
    ]
  }

  renderFooter() {
    return [
      <button class="btn--link-grey" type="button" onClick={this.cancel}>
        Annuler
      </button>,
      <button class="button is-action-primary"
              type="button"
              onClick={() => this.commit()}>
        Ajouter
      </button>
    ];
  }

}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-0b169786/search-list-modal.tsx" });